import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import moment from 'moment-timezone'
import WeatherHourly from './WeatherHourly'
import Loading from '../../components/util/Loading'
import WeatherDay from './WeatherDay'

const WeeklyWeather = ({loading, locationData}) => {
  const [expandedDay, setExpandedDay] = useState('')

  const handleDayClick = useCallback((date) => {
    setExpandedDay(prevDate => prevDate === date ? '' : date)
  }, [])

  const handleHourlyClick = useCallback(() => {
    setExpandedDay('')
  }, [])

  return (
    <div className='weekly-weather'>
      <div className='weekly-weather-day-header'>
        <h3>10 vrk sää</h3>
      </div>
      <Loading loading={ loading }>
        <ul className='weekly-weather-days'>
          { locationData.toArray().map((dailyData, i) => {

            const date = dailyData.get('date')
            let label = moment(date).format('dd D.M.')
            label = label.charAt(0).toUpperCase() + label.slice(1) // Capitalize
            if (i === 0) {
              label = 'Tänään'
            }

            return (
              <li className='weekly-weather-list-wrapper' key={ date }>
                <WeatherDay
                  dailyData={ dailyData }
                  isExpanded={ expandedDay === date }
                  label={ label }
                  onDayClick={ handleDayClick }
                />
                { expandedDay === date &&
                  <WeatherHourly
                    onComponentClick={ handleHourlyClick }
                    dailyData={ dailyData }
                  />
                }
              </li>
            )
          }) }
        </ul>
      </Loading>
    </div>
  )
}

WeeklyWeather.propTypes = exact({
  loading: PropTypes.bool.isRequired,
  locationData: ImmutablePropTypes.list.isRequired,
})

export default WeeklyWeather
